export default __webpack_public_path__ + "static/media/valleyPort8.be197e65.png";